<template>
  <div>
    <div :style="customStyle" class="poll-content">
      <div class="scrollable-container">
        <div v-if="0" class="test">
           Width:{{ deviceWidth }}
        </div>
        <div class="headline">
          <Headline></Headline>
        </div>
        <!-- don't remove this div -->
        <!-- <div class="container">  -->

        <component ref="mobileRenderer" v-bind:is="renderer"></component>
        <!-- </div> -->
      </div>
    </div>
    <a v-if="0 && isMobileView && isOwner" href="#" class="float">
      <font-awesome-icon
        @click="enterNewParticipant"
        class="my-float"
        :icon="['fal', 'plus']"
      />
    </a>
  </div>
</template>

<script>
import Headline from '@/components/Rendering/Headline.vue';
import RenderData from '@/components/Rendering/RenderData.vue';
import RenderEvent from '@/components/Rendering/RenderEvent.vue';
import RenderEventMobile from '@/components/Rendering/RenderEventMobile.vue';
import RenderDataMobile from '@/components/Rendering/RenderDataMobile.vue';
import { deviceMixin } from '../mixins/DeviceMixins';
import { modalParticipantMixins } from '../mixins/ModalParticipantMixins';

const customTemplate = require('../../shared/customTemplate');
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
  name: 'Renderer',

  mixins: [deviceMixin, modalParticipantMixins],

  components: {
    Headline,
    RenderData,
    RenderEvent,
    RenderDataMobile,
    RenderEventMobile,
  },
  props: [],
  data() {
    return {
      clientWidth: 0,

    };
  },

  methods: {
    // enterNewParticipant() {
    //   console.log('enterNewParticipant');
    //   this.$refs.mobileRenderer.enterNewParticipant();
    // },
    ...mapActions(['updateSelectedTemplate', 'setDarkMode']),
    updateLogo() {
      if(this.poll.design) {
        this.updateSelectedTemplate(this.poll.design).then(() => {
          this.renderValue();
        });
      }
    },
    renderValue() {
      let value = (this.getSelectedTemplate.config.answerGridSection.selectedMode == 'dark');
      this.setDarkMode(value).then(() => {
          customTemplate.renderHTML(this.getSelectedTemplate);
      });
    }
  },

  computed: {
    ...mapState({
      poll: (state) => state.poll.poll,
    }),
    ...mapGetters({
            isOwner: 'isOwner',
            getSelectedTemplate: 'getSelectedTemplate'
        }),



    renderer() {
      console.log('Renderer mobileView:', this.mobileView, this.poll.type);
      if (this.poll.type == 2) {
        return this.isMobileView ? RenderEventMobile : RenderEvent;
      }
      return this.isMobileView ? RenderDataMobile : RenderData;
    },

    customStyle() {
      if(this.poll.bg_image_path) {
        return `background-image: url('${this.poll.bg_image_path}')`;
      }
      else if (this.$store.getters.bgImage) {
        let bgImageUrl = this.$store.getters.bgImage.url;
        let bgStyle = `background-image: url('${bgImageUrl}')`;
        return bgStyle;
      } else {
        return '';
      }
    },
  },

  beforeCreate() {
    console.info('(Render) beforeCreate:', Date.now());
  },

  beforeMount() {
    console.info('(Render) beforeMount:', Date.now());
  },


  mounted() {
    console.info('(Renderer) mounting started');
    this.updateLogo();
  },
  created() {

  },
};
</script>

<style scoped lang="scss">
@import '@/styles/colors';

.poll-content {
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  min-height: 100vh;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.scrollable-container {
  overflow: auto;
  padding-top: 0px;
  padding-bottom: 10px;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.headline {
  margin-bottom: 10px;
}

// .float {
//   position: fixed;
//   width: 40px;
//   height: 40px;
//   bottom: 10px;
//   right: 10px;
//   background-color: white;
//   color: $mid-grey;
//   border-radius: 50px;
//   text-align: center;
//   box-shadow: 2px 2px 3px #999;
// }

// .my-float {
//   margin-top: 13px;
//   font-size: 1.2rem;
// }
</style>
